const webchatContainerId = 'twilio-webchat-widget-root';

const widgetChat = document.getElementById(webchatContainerId);

if (widgetChat) {

    const chatUser = JSON.parse(window.user);

    console.log("Initializing Twilio Web Chat with user data:", chatUser?.date_of_birth);

    const currentTheme = window.theme;
    const ThemeObject = {
        rootBackgroundColor: currentTheme === 'aurora' ? '#ffffff' : '#ffffff',
        headerBackgroundColor: currentTheme === 'aurora' ? '#4a4bb8' : '#3e7f87',
        btnLetsChatBackgroundColor: currentTheme === 'aurora' ? '#4a4bb8' : '#e69e4f',
        btnLetsChatDisabledBackgroundColor: currentTheme === 'aurora' ? '#cecece' : '#cecece',
        btnOpenCloseBackgroundColor: currentTheme === 'aurora' ? '#4a4bb8' : '#3e7f87',
        myMessagesBubbleBackgroundColor: currentTheme === 'aurora' ? '#535397' : '#55959d',
    }

    const style = document.createElement('style');
    style.innerHTML = `
        #${webchatContainerId} {
            position: relative;
            z-index: 9999;
        }
        #${webchatContainerId} header {
            background-color: ${ThemeObject.headerBackgroundColor};
        }
        #${webchatContainerId} > div > div > div > div > button {
            background-color: ${ThemeObject.btnOpenCloseBackgroundColor};
        }
        #${webchatContainerId} form button:disabled {
            background-color: ${ThemeObject.btnLetsChatDisabledBackgroundColor};
            border: 1px solid ${ThemeObject.btnLetsChatDisabledBackgroundColor};
        }
        #${webchatContainerId} form button {
            background-color: ${ThemeObject.btnLetsChatBackgroundColor};
            border: 1px solid ${ThemeObject.btnLetsChatBackgroundColor};
            box-shadow: none;
        }
        #${webchatContainerId} form button:hover {
            color: #fff;
        }
        #${webchatContainerId} > div > div > div > div > div {
            background-color: ${ThemeObject.rootBackgroundColor};
        }
        #${webchatContainerId} .twiliowebchat-syx6lh {
            background-color: ${ThemeObject.myMessagesBubbleBackgroundColor};
        }
        #${webchatContainerId} .twiliowebchat-1a4ndlq, #${webchatContainerId} .twiliowebchat-pe4vrq
        {
            color: #ffffff;
        }
    `;
    document.head.appendChild(style);

    window.addEventListener("load", () => {

        if (typeof Twilio === 'undefined') {
            console.warn("Twilio SDK not loaded.");
            return;
        }

            const appConfig = {
                deploymentKey: widgetChat.dataset.deploymentKey,
                appStatus: widgetChat.dataset.appStatus || 'open',
                theme: {
                    isLight: widgetChat.dataset.isLight === 'true',
                },
                context: { 
                    locationOrigin: window.location.origin,
                    user_id: chatUser?.id || 'guest',
                },
                disablePreEngagementForm: false,
                preEngagementConfig: {
                    title: chatUser ? "Pre-Chat Form" : "Welcome to Chat",
                    description: "Complete this form to start the chat",
                    submitLabel: "Let's chat",
                    footerLabel: "",
                    fields: [
                        {
                            label: "Name",
                            type: "InputItem",
                            attributes: {
                                name: "friendlyName",
                                type: "text",
                                placeholder: "Enter your name",
                                required: true,
                                pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                                readOnly: false,
                                value: chatUser?.full_name ?? ""
                            }
                        },
                        {
                            label: "Email address",
                            type: "InputItem",
                            attributes: {
                                name: "email",
                                type: "email",
                                placeholder: "Enter your email address",
                                required: true,
                                readOnly: false,
                                value: chatUser?.email ?? "",
                                pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
                            }
                        },
                        {
                        label: "Ask a question",
                        type: "TextareaItem",
                            attributes: {
                                name: "query",
                                type: "text",
                                placeholder: "Type your question here",
                                required: true
                            }
                        },
                    ]
                }
            };

        Twilio.initWebchat(appConfig);
    });

} else {
    console.warn("Twilio Web Chat widget root element not found.");
}